var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"รายงานยอดขายของร้านค้าลูกค้าขายส่ง","link_back":"managepos"}}),_c('MenuPartner'),_c('report_wholesale')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }